var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter"},[_c('a',{attrs:{"href":_vm.BaseUrl + 'downloader/analiza',"target":"_blank"}},[_c('div',{staticClass:"number"},[_vm._v("Analiza Feedaback-ului studenților pentru Semestrul II, Anul Universitar 2021 - 2022")]),_c('div',{staticClass:"info"},[_vm._v("Descărcare Analiza")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }